import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/nationwide/index.vue'),
    meta: {
      title: "土拉宝全国大数据"
    },
  },
  {
    path: '/city',
    name: 'city',
    component: () => import('../views/city/index.vue'),
    meta: {
      title: "土拉宝城市调度大数据"
    },
  }
]
const router = new VueRouter({
  routes
})

export default router